import React, { useEffect, Component } from "react";
import "@/App.css";
import Lenis from "lenis";
import Navbar from "@/components/nuun/Navbar";
import Hero from "@/components/nuun/Hero";
import Marquee from "@/components/nuun/Marquee";
import Manifesto from "@/components/nuun/Manifesto";
import MenuSection from "@/components/nuun/MenuSection";
import Reviews from "@/components/nuun/Reviews";
import Story from "@/components/nuun/Story";
import Visit from "@/components/nuun/Visit";
import Footer from "@/components/nuun/Footer";

class ErrorBoundary extends Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false };
  }
  static getDerivedStateFromError() {
    return { hasError: true };
  }
  render() {
    if (this.state.hasError) {
      return (
        <div className="min-h-screen bg-charcoal text-bone flex items-center justify-center p-8">
          <p className="font-mono text-sm tracking-widest text-dim">
            SOMETHING BURNT — PLEASE REFRESH.
          </p>
        </div>
      );
    }
    return this.props.children;
  }
}

function Site() {
  useEffect(() => {
    const lenis = new Lenis({ lerp: 0.09, smoothWheel: true });
    window.__lenis = lenis;
    let raf;
    const loop = (t) => {
      lenis.raf(t);
      raf = requestAnimationFrame(loop);
    };
    raf = requestAnimationFrame(loop);
    return () => {
      cancelAnimationFrame(raf);
      lenis.destroy();
      window.__lenis = null;
    };
  }, []);

  return (
    <div className="bg-charcoal text-bone font-sans antialiased selection:bg-ember">
      <div className="grain" aria-hidden="true" />
      <Navbar />
      <main>
        <Hero />
        <Marquee />
        <Manifesto />
        <MenuSection />
        <Reviews />
        <Story />
        <Visit />
      </main>
      <Footer />
    </div>
  );
}

function App() {
  return (
    <ErrorBoundary>
      <Site />
    </ErrorBoundary>
  );
}

export default App;
